<template>
  <div class="main">
    <router-view :key="keys()" @goscrolltoptwo="scrolltop"/>
  </div>
</template>

<script>
export default {
  name: 'appMain',
  mounted () {},
  methods: {
    scrolltop () {
      this.$emit('goscrolltop');
    },
    keys () {
      return Date.now();
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/components/appMain.vue